import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { MatIcon } from "@angular/material/icon";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { CommonModule } from '@angular/common';
import { AuthService } from '../../service/auth.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-verify-email',
  standalone: true,
  templateUrl: './verify-email.component.html',
  styleUrl: './verify-email.component.css',
  imports: [MatIcon, MatProgressSpinner,CommonModule,RouterModule, TranslateModule]
})
export class VerifyEmailComponent implements OnInit, OnDestroy {

  isLoading: boolean = true;
  isSuccess: boolean = false;
  message: string = '';
  errorMessage: string = '';

  private successMessageKey: string = '';
  private errorMessageKey: string = '';
  private langChangeSubscription?: Subscription;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private auth: AuthService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.langChangeSubscription = this.translate.onLangChange.subscribe(() => {
      this.refreshTranslatedMessages();
    });

    this.auth.setLoggedIn(false);

    const token = this.route.snapshot.queryParamMap.get('token');

    if (!token) {
      this.isLoading = false;
      this.isSuccess = false;
      this.errorMessageKey = 'auth.verify.errors.missing-token';
      this.successMessageKey = '';
      this.refreshTranslatedMessages();
      return;
    }

    this.verifyEmail(token);
  }

  ngOnDestroy(): void {
    this.langChangeSubscription?.unsubscribe();
  }

  verifyEmail(token: string): void {
    this.http.get(`${environment.apiUrl}/api/auth/verify?token=${token}`, { responseType: 'text' })
      .subscribe({
        next: () => {
          this.isLoading = false;
          this.isSuccess = true;
          this.successMessageKey = 'auth.verify.success-default-message';
          this.errorMessageKey = '';
          this.refreshTranslatedMessages();
        },
        error: () => {
          this.isLoading = false;
          this.isSuccess = false;
          this.errorMessageKey = 'auth.verify.errors.invalid-or-expired';
          this.successMessageKey = '';
          this.refreshTranslatedMessages();
        }
      });
  }

  goToLogin(): void {
    this.router.navigate(['/login']);
  }

  goToResendVerification(): void {
    this.router.navigate(['/resend-verification']);
  }

  private refreshTranslatedMessages(): void {
    this.message = this.successMessageKey ? this.translate.instant(this.successMessageKey) : '';
    this.errorMessage = this.errorMessageKey ? this.translate.instant(this.errorMessageKey) : '';
  }
}
